import { WithId } from 'types/common'
import { ActivityStatus } from 'types/form'
import { APICfg } from '../api'

export type QuestionResponse = WithId & {
  question: string
  response: string
  status: ActivityStatus
}

// TODO to type supplieredService as ProductServiceDiscriminator
export type ServiceBrief = {
  briefConfirmed?: boolean
  supplieredService: string
  questionResponses: QuestionResponse[]
}

type APIEventBrief = ServiceBrief[]

export type EventBrief = APIEventBrief

const apiCfg: APICfg = {
  endpoint: '',
  getOneEndpoint: 'event/:id/brief',
  parse: (res: APIEventBrief): EventBrief => res,
  write: async (req: EventBrief): Promise<APIEventBrief> => req,
}

export default apiCfg
